/**
 * Multi-level referral points — % of profit margin per upline level.
 * No separate company royalty slice; undistributed % stays with margin.
 */

export const REFERRAL_COMMISSION_MAX_LEVELS = 10;

export const REFERRAL_COMMISSION_RATES = {
  1: 100.0,
  2: 25.0,
  3: 15.0,
  4: 10.0,
  5: 10.0,
  6: 5.0,
  7: 5.0,
  8: 5.0,
  9: 2.5,
  10: 2.5,
};

export const REFERRAL_COMMISSION_TOTAL_PERCENT = Object.values(
  REFERRAL_COMMISSION_RATES
).reduce((sum, r) => sum + r, 0);

/** No fixed company % — unused levels or short chain → undistributed profit */
export const REFERRAL_COMPANY_ROYALTY_PERCENT = 0;

export function getReferralCommissionRate(level) {
  return REFERRAL_COMMISSION_RATES[Number(level)] || 0;
}
